import { render, staticRenderFns } from "./NameTest.vue?vue&type=template&id=0dd094b9&scoped=true&"
import script from "./NameTest.vue?vue&type=script&lang=ts&"
export * from "./NameTest.vue?vue&type=script&lang=ts&"
import style0 from "./NameTest.vue?vue&type=style&index=0&id=0dd094b9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd094b9",
  null
  
)

export default component.exports